import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M0.5,-2h1v1h-1zM-6.5,-1h0.5v0.5h-0.5zM0.5,-1h1.5v1h-1.5zM-6.5,-0.5h1v0.5h-1zM6,-0.5h0.5v0.5h-0.5zM-6,0h1v0.5h-1zM1,0h1v0.5h-1zM5,0h1v0.5h-1zM-6,0.5h1.5v0.5h-1.5zM-0.5,0.5h1.5v0.5h-1.5zM4,0.5h2v0.5h-2zM-6,1h0.5v0.5h-0.5zM-5,1h2v0.5h-2zM2,1h4v0.5h-4zM-5.5,1.5h4v0.5h-4zM0,1.5h2.5v0.5h-2.5zM3,1.5h1v1h-1zM4.5,1.5h1v0.5h-1zM-4,2h6.5v0.5h-6.5zM-3,2.5h1v0.5h-1zM-1.5,2.5h4.5v0.5h-4.5z',
    },
    {
      paint: 'rock',
      d: 'M-2.5,-3.5h1v0.5h-1zM-4.5,-3h7v0.5h-7zM-5,-2.5h9v0.5h-9zM-5.5,-2h1.5v0.5h-1.5zM-3.5,-2h2v0.5h-2zM-1,-2h1v0.5h-1zM1.5,-2h1.5v0.5h-1.5zM3.5,-2h1.5v0.5h-1.5zM-6,-1.5h2.5v0.5h-2.5zM-1.5,-1.5h1.5v0.5h-1.5zM3,-1.5h2.5v0.5h-2.5zM-6,-1h1v0.5h-1zM-4.5,-1h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1zM4,-1h2v0.5h-2zM-5.5,-0.5h0.5v0.5h-0.5zM-1.5,-0.5h1.5v1h-1.5zM4,-0.5h0.5v0.5h-0.5zM-5,0h1v0.5h-1zM4,0h1v0.5h-1zM-4,0.5h0.5v0.5h-0.5zM3,0.5h1v0.5h-1zM-1.5,1.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'shadow',
      d: 'M-4,-2h0.5v0.5h-0.5zM-1.5,-2h0.5v0.5h-0.5zM3,-2h0.5v0.5h-0.5zM-3.5,-1.5h2v0.5h-2zM1.5,-1.5h1.5v0.5h-1.5zM-4,-1h2.5v1h-2.5zM2,-1h2v0.5h-2zM2,-0.5h1v0.5h-1zM3.5,-0.5h0.5v0.5h-0.5zM4.5,-0.5h1.5v0.5h-1.5zM-3,0h1.5v0.5h-1.5zM-4.5,0.5h0.5v0.5h-0.5zM-5.5,1h0.5v0.5h-0.5zM4,1.5h0.5v0.5h-0.5zM-2,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M3,-0.5h0.5v0.5h-0.5zM-4,0h1v0.5h-1zM2,0h2v0.5h-2zM-3.5,0.5h3v0.5h-3zM1,0.5h2v0.5h-2zM-3,1h5v0.5h-5z',
    },
    {
      paint: 'torchFlame',
      d: 'M0,-2h0.5v1h-0.5zM-0.5,-1h1v0.5h-1zM0,-0.5h0.5v0.5h-0.5zM0,0h1v0.5h-1z',
    },
    { paint: 'epicMarble', d: 'M-5,-1h0.5v0.5h-0.5zM-5,-0.5h1v0.5h-1zM2.5,1.5h0.5v1h-0.5z' },
  ],
  pixels: 251,
};
export const sprites: readonly PixelSprite[] = [variant0];
